<div style="display: flex; max-height: 100vh">
  <div style="display: flex; flex-direction: column; flex: 1vh">
    <div style="display: flex; flex-direction: row; flex: 100vh">
      <div style="display: flex; flex-direction:column; flex: 0 50vw; align-items: center;">
        <div style="width: 240px; margin: auto;">
          <dynamic-form [model]="form" (clickSubmit)="login($event)" (clickButton)="clickButton($event)" [loading]="isLoading">
          </dynamic-form>
          <div style="text-align: right; padding-top: 5px; margin-right: -7px">
            <a style="color:#0094ff; font-size: 13px; text-decoration: underline; cursor: pointer" (click)="clickButton('reset')">Reset Password</a>
          </div>
        </div>
      </div>
      <div class="login-hero">
        <div class="login-hero-text">
          Join the most satisfied auto transport customers in the country.
        </div>
      </div>
    </div>
  </div>
</div>


